import { combineEpics } from 'redux-observable';
// ---- external imports ------

import  fetchUpdatedLogbookEpic  from './fetchUpdatedLogbookEpic';
import onDistributedProfitSubmissionEpic from './onProfitDistributionEpic';
// ---  local imports ----

export default combineEpics(
	fetchUpdatedLogbookEpic,
	onDistributedProfitSubmissionEpic
);

